/* eslint-disable max-len */

import { useTranslation } from 'react-i18next';
import { CustomError, ManageCodeLabelColumn } from '../../../../components';
import { block } from '../../../../entityModel';
import {
  TXT_DATA_NOT_FOUND,
  TXT_DELETE,
  TXT_EDIT,
  TXT_LOADING
} from '../../../../translations/translationConstants';
import { capitalizeFirstLetter } from '../../../../shared/stringFunctions';
import { getBlockOutput } from '../../../../api';
import { ApolloError } from '@apollo/client';

export interface ManageBlocksTableBodyProps {
  error?: ApolloError;
  loading: boolean;
  data?: getBlockOutput;
  columns: ManageCodeLabelColumn[];
  onEdit: (block: block) => void;
  onDelete: (block: block) => void;
}

export const ManageBlocksTableBody =
  ({ error, columns, loading, data, onEdit, onDelete }: ManageBlocksTableBodyProps) => {
    const { t } = useTranslation();
    return (
      <tbody>
        {
          loading &&
          <tr>
            <td colSpan={columns.length} style={{ textAlign: 'center' }}>
              <h3>
                {t(TXT_LOADING).toUpperCase()}
              </h3>
            </td>
          </tr>
        }
        {
          !loading && error && error.message &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {error.message}
              </CustomError>
            </td>
          </tr>
        }
        {
          !loading && data &&
          data.blocks && data.blocks.items &&
          data.blocks.items.length > 0 &&
          data.blocks.items.map((block) => (
            <tr key={`row-${block.id}`}>
              <td>
                {block.code}
              </td>
              <td>
                {block.label}
              </td>
              <td align='center'>
                <button
                  data-target="#modal-block-editor"
                  data-toggle="modal"
                  className='btn btn-primary'
                  aria-label="edit block"
                  onClick={() => onEdit(block)}>
                  {t(TXT_EDIT).toUpperCase()}
                </button>
              </td>
              <td align='center'>
                <button
                  data-target="#modal-default"
                  data-toggle="modal"
                  className='btn btn-danger'
                  aria-label="delete block"
                  type="button"
                  onClick={() => onDelete(block)}>
                  {t(TXT_DELETE).toUpperCase()}
                </button>
              </td>
            </tr>
          ))
        }
        {
          !loading &&
          (!data ||
            !data.blocks ||
            !data.blocks.items ||
            data.blocks.items.length <= 0) &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {capitalizeFirstLetter(t(TXT_DATA_NOT_FOUND))}
              </CustomError>
            </td>
          </tr>
        }
      </tbody>
    );
  };
